<template>
    <v-footer :fixed="fixed" app>
        <v-row justify="center">
            <v-btn
                href="https://whitedeergroup.com/"
                target="_blank"
                rel="noreferrer"
                color="primary"
                text
                class="my-2"
            >
                &copy; {{ new Date().getFullYear() }}
                <strong>White Deer Group</strong>
            </v-btn>

            <v-btn
                href="https://mydocport.com/"
                target="_blank"
                rel="noreferrer"
                color="primary"
                text
                class="my-2 font-weight-bold"
            >mydocport.com</v-btn>
        </v-row>
    </v-footer>
</template>

<script>
import { authGate } from '@/mixins/authGate'
export default {
    name: 'PageFooter',
    mixins: [authGate],
    data() {
        return {
            fixed: false,
        }
    },
}
</script>
